import type {
  OmniChannelWorkspaceDetail,
  WorkspaceEnvironmentKeys,
  WorkspacePayload,
  WorkspaceStatus,
  WorkspaceStatusConfig,
} from '../lib/api/workspaces';
import { WORKSPACE_STATUS_CONFIG_MAP } from '../lib/constants/workspace';
import type { FilterConfigItem } from '../modules/GenomeWorkspaceView/LeftView/components/FilterConfig/FilterConfigTypes';
import { SITE_ENGAGEMENT_ROOT_FILTERS } from './containsEngagementsFilters';

export const getStatusConfig = (status: WorkspaceStatus): WorkspaceStatusConfig => {
  return WORKSPACE_STATUS_CONFIG_MAP[status];
};

export const isDraftWorkspace = (status_config?: WorkspaceStatusConfig) => !!status_config?.isDraft;

export const isPublishedWorkspace = (status_config?: WorkspaceStatusConfig) => !!status_config?.createList;

export const isSavedWorkspace = (status_config?: WorkspaceStatusConfig) => {
  return !!status_config && !status_config.isDraft && !status_config.createList && !status_config.archived;
};
``;
export const getSiteRelatedFilters = (filterConfigs: FilterConfigItem[]): string[] => {
  const siteConfig = filterConfigs.find((c) => c.filterName === 'site_events_filter');
  if (!siteConfig) return [SITE_ENGAGEMENT_ROOT_FILTERS];
  return [siteConfig.filterName, ...(siteConfig.secondaryFilters || []), ...(siteConfig.auxiliaryFilters || [])];
};

export const OMNI_CHANNEL_MESSAGES = {
  FILTER_LOCKED: 'This filter is required for Audience Manager Audiences and cannot be removed.',
  CLEAR_FILTERS_LOCKED: 'Cannot clear all the filters since the workspace is linked to the Audience Manager Audience',
  MODIFICATION_RESTRICTED:
    'Site Engagement configurations are locked for Audience Manager Audiences. Previously saved settings cannot be modified or removed.',
  ERROR_TOOLTIP: 'Audience Manager configuration cannot be modified',
};

type OmniChannelDetails = OmniChannelWorkspaceDetail & {
  [key in WorkspaceEnvironmentKeys]?: OmniChannelWorkspaceDetail;
};

export const hasOmniChannelFlag = (workspace?: WorkspacePayload): boolean => {
  if (!workspace?.workspace_details) return false;
  const details = workspace.workspace_details as OmniChannelDetails;
  const hasFlag = !!details.prod?.omnichannel?.lifeFlag || !!details.omnichannel?.lifeFlag;

  return isPublishedWorkspace(workspace.workspace_status_config) && hasFlag;
};
